<template>
  <tw-modal :id="modalId" ref="modal" :ok-disabled="LoadingSendingSupportRequest" :loading="LoadingSendingSupportRequest" size="xl" title="Send support request" variant="primary" @opened="opened" @ok="prepareToSendSupportRequest">
    <div class="mb-4">
      <h2>Other Support methods</h2>
      <p>You can also contact via email at <a class="font-weight-bold" href="mailto:help@grouprev.com">help@grouprev.com</a></p>
      <!-- <p>Or via phone number: Phone: <a href="tel:800-454-1264">800-454-1264</a> </p> -->
    </div>
    <tw-input v-model="SupportMessageName" label="Your Name:" />
    <tw-email v-model="SupportMessageEmail" label="Your Email:" />
    <tw-textarea v-model="SupportMessage" label="Your Message:" />
    <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
    <template #ok>
      Send support request
    </template>
  </tw-modal>
</template>

<script>
import axios from 'axios'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwTextarea from '@/components/generic/forms/tw-textarea.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import modalCascadeMixin from '@/mixins/modalCascadeMixin.js'
import { useSupportRequestsStore } from '@/stores/supportRequests.js'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwEmail from '@/components/generic/forms/tw-email.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import TwInput from '@/components/generic/forms/tw-input.vue'
export default {
  name: 'SendSupportRequestModal',
  components: { TwInput, TwEmail, TwValidationErrors, TwLoadingSpinner, TwTextarea, TwCard, TwModal },
  mixins: [modalCascadeMixin, loggedInUserMixin],
  props: {
    modalId: {
      type: String,
      default: 'send-support-request-modal'
    }
  },
  data () {
    return {
      LoadingSendingSupportRequest: false,
      ValidationErrorMessage: null,
      SupportMessageName: null,
      SupportMessageEmail: null,
      SupportMessage: null,
      SupportIncludeScreenshot: true
    }
  },
  computed: {
    supportRequestScreenshotBlob() {
      return useSupportRequestsStore().supportRequestScreenshotBlobGet
    }
  },

  methods: {
    opened(){
      if(this.loggedInUser) {
        this.SupportMessageEmail = this.loggedInUser.email
        this.SupportMessageName = this.loggedInUser.name
      }
    },
    prepareToSendSupportRequest (bvEvent) {
      if (bvEvent) {
        bvEvent.preventDefault()
      }
      if (this.supportRequestScreenshotBlob) {
        this.supportRequestScreenshotBlob.toBlob(this.sendSupportRequest)
      } else {
        this.sendSupportRequest()
      }
    },
    async sendSupportRequest (blob) {
      try {
        this.LoadingSendingSupportRequest = true
        const formData = new FormData()
        if (blob) {
          formData.append('screenshot', blob)
        }
        formData.set('message', this.SupportMessage)
        formData.set('url', window.location.href)
        formData.set('name', this.SupportMessageName)
        formData.set('email', this.SupportMessageEmail)
        // formData.set('browser_console_output')
        const { data } = await axios.post('/api/v1/support-request-submit', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        this.LoadingSendingSupportRequest = false
        this.SupportMessage = null
        this.$refs.modal.close()
        this.$notify('Your support request has been successfully sent!')
      } catch (e) {
        this.LoadingSendingSupportRequest = false
        this.ValidationErrorMessage = e.response.data
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>

</style>
